import React from 'react';
import { Link } from 'react-router-dom';

const SITE_URL = 'https://geograftour.com/';

export const Banner = () => `
  <article className="infosearch">
    <h2 className="pink-c">Купите тур сейчас — оплачивайте позже!</h2>
    <br />
    Любой тур в Географии можно купить в рассрочку! 50 дней на оплату 0%
    переплаты.
    <a href=${SITE_URL}tourist/rassrochka-ot-paylate/>
      Подробнее...
    </a>
    <br />
    <br />
    Покупаешь тур с вылетом через 2 месяца и более, вноси 50% предоплаты. Полная
    оплата тура нужна за месяц до даты вылета!
  </article>`;

export const InfoBanner = () => (
  <article className="tour__fact tour__block">
    <div className="fact__body">
      <div className="fact__item">
        <img
          src={`${SITE_URL}/static/index/img/hands.png`}
          className="fact__image"
          alt=""
          loading="lazy"
        />
        <h4 className="fact__header">Географии доверяют</h4>
        <p className="fact__description">
          100 000 довольных туристов за прошлый год
        </p>
      </div>
      <div className="fact__item">
        <img
          src={`${SITE_URL}/static/index/img/pc.png`}
          className="fact__image"
          alt=""
          loading="lazy"
        />
        <h4 className="fact__header">География это -</h4>
        <p className="fact__description">
          Один интернет-магазин и 450 офисов продаж
        </p>
      </div>
      <div className="fact__item">
        <img
          src={`${SITE_URL}/static/index/img/calend.png`}
          className="fact__image"
          alt=""
          loading="lazy"
        />
        <h4 className="fact__header">География проверена временем</h4>
        <p className="fact__description">
          Первый магазин открыт в 2007, онлайн магазин работает с 2015
        </p>
      </div>
    </div>
  </article>
);

export const FeatureBanner = () => (
  <article className="ya_banner_inst_plan desktop">
    <div className="ya_head">Купите тур сейчас — оплачивайте позже!</div>
    <div className="ya_subhead">
      Любой тур в Географии можно купить в рассрочку!
    </div>
    <div className="cn-around_center cont">
      <div className="cn-start">
        <div className="numbers">
          0 <i className="fa fa-rub"></i>
        </div>{' '}
        <div className="ttxt">
          без
          <br />
          предоплаты
        </div>
      </div>{' '}
      <div className="cn-space">
        <div className="numbers">0%</div>{' '}
        <div className="ttxt">
          переплаты
          <br />
          при оплате в срок{' '}
        </div>
      </div>{' '}
      <div className="cn-end">
        <div className="numbers">30</div>{' '}
        <div className="ttxt">
          дней
          <br />
          на оплату
        </div>
      </div>
    </div>{' '}
    <Link to="/tourist/rassrochka-ot-paylate/" target="_blank">
      Как оформить рассрочку онлайн
    </Link>
  </article>
);

export const InfoFeature = () => (
  <article className="tour__feature  tour__block">
    <div className="feature__title">Интернет магазин — География!</div>
    <div className="feature__body">
      <p className="feature__item feature__item--first">
        <img
          src={`${SITE_URL}/static/index/img/like.png`}
          className="feature__image"
          alt=""
          loading="lazy"
        />
        <span className="feature__text">
          <b>
            Честная
            <br />
            цена
          </b>
        </span>
      </p>
      <p className="feature__item">
        <img
          src={`${SITE_URL}/static/index/img/tury.png`}
          className="feature__image"
          alt=""
          loading="lazy"
        />
        <span className="feature__text">
          <b>
            Реальные
            <br />
            туры
          </b>
        </span>
      </p>
      <p className="feature__item">
        <img
          src={`${SITE_URL}/static/index/img/pokupka.png`}
          className="feature__image"
          alt=""
          loading="lazy"
        />
        <span className="feature__text">
          <b>
            Удобная
            <br />
            покупка
          </b>
        </span>
      </p>
    </div>
  </article>
);

export const FactBanner = ({
  text = 'Турция омывается четырьмя морями - Эгейским, Средиземным, Мраморным и Черным. Именно поэтому пляжи Турции считаются одними из лучших в рейтинге европейских туристов.',
}) => <article className="facts">{text}</article>;
